import PropTypes from 'prop-types';

import classNames from 'classnames';

import BlogArticleSample from './articleSample';

import Pagination from '@js/components/materialize/pagination';

function BlogList({
                      articles = [],
                      isPaginated = true,
                      totalPages,
                      onPaginationClick,
                      isCol = false
                  }) {
    return (
        <div className="row">
            {
                articles.map((article) => (
                    <div key={article.id}
                         className={classNames('col s12', {'m6 l4': isCol})}>
                        <BlogArticleSample article={article}
                                           isCol={isCol}/>
                    </div>
                ))
            }

            {
                !!isPaginated &&
                <Pagination totalPages={totalPages}
                            onPaginationClick={onPaginationClick}/>
            }
        </div>
    );
}

BlogList.propTypes = {
    articles: PropTypes.array,
    isPaginated: PropTypes.bool,
    totalPages: PropTypes.number,
    onPaginationClick: PropTypes.func,
    isCol: PropTypes.bool
};

export default BlogList;
